import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { MedicosService } from '@services/users/medicos/medicos.service';
import { AlertService } from '@services/utils/alerts/alert.service';
import { DateService } from '@services/utils/date/date.service';
import { ValidationService } from '@services/utils/validations/validation.service';
import { first } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.page.html',
  styleUrls: ['./delete-account.page.scss']
})
export class DeleteAccountPage implements OnInit {
  deleteAccountForm: FormGroup
  id = ''
  email = ''
  eyeImage: string = 'eye-off'
  typeInput: string = 'password'

  constructor(
    private alertController: AlertController,
    public modalController: ModalController,
    public formBuilder: FormBuilder,
    private validationService: ValidationService,
    private alertService: AlertService,
    public medicosService: MedicosService,
    private storage: Storage,
    private router: Router,
    private platform: Platform,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.getDataUser()
    this.validateForm()
  }

  getDataUser() {
    this.storage.get(environment.localStorage).then((val) => {
      if (val != null) {
        this.id = val.identification
        this.email = val.email
      }
    })
  }

  changeImage() {
    if (this.eyeImage == 'eye-off') {
      this.eyeImage = 'eye'
      this.typeInput = 'text'
      setTimeout(() => {
        this.eyeImage = 'eye-off'
        this.typeInput = 'password'
      }, 2000)
    } else {
      this.eyeImage = 'eye-off'
      this.typeInput = 'password'
    }
  }

  deleteAccount() {
    if (this.deleteAccountForm.invalid) {
      this.showDetailsError()
      return false
    }

    this.medicosService
      .deleteAccount(this.getData())
      .pipe(first())
      .subscribe(
        (res) => {
          this.success(res)
        },
        (err) => {
          this.error()
        }
      )
  }

  showDetailsError() {
    this.deleteAccountForm.markAllAsTouched()
    this.alertService.statusAlert('Error!', 'Faltan campos por llenar o la información no es valida.')
  }

  success(res) {
    this.alertService.dismiss().then(async () => {
      if (res.error) {
        this.alertService.statusAlert('Error!', 'No ha podido eliminar la cuenta')
      } else {
        const alert = await this.alertController.create({
          header: 'Eliminación de cuenta exitosa!',
          backdropDismiss: false,
          buttons: [
            {
              text: 'OK',
              role: 'confirm',
              handler: () => {
                this.router.navigate(['login'])
              }
            }
          ]
        })

        await alert.present()

        this.storage.set(environment.localStorage, null)
        if (this.platform.is('cordova') || this.platform.is('capacitor'))
          this.storage.set(environment.storageBiometric, null)
        this.modalController.dismiss()
      }
    })
  }

  error() {
    this.alertService.dismiss().then(() => {
      this.alertService.statusAlert('Error!', 'Contraseña incorrecta')
    })
  }

  getData() {
    let data = this.deleteAccountForm.controls
    let deleteAccount = {
      identification: this.id,
      email: this.email,
      password: data.password.value,
      reason: data.reason.value,
      message: data.message.value,
      date_exec: this.dateService.getDate()
    }
    return deleteAccount
  }

  validateForm() {
    this.deleteAccountForm = this.formBuilder.group({
      password: ['', this.validationService.Validation(3, 51, 'onlyPassword')],
      reason: ['', this.validationService.Validation(4, 31, 'anyText')],
      message: ['', this.validationService.Validation(8, 71, 'anyText')]
    })
  }

  get errorControl() {
    return this.deleteAccountForm.controls
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
